import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {GalleriaModule} from "primeng/galleria";
import {NgIf} from "@angular/common";
import {PrimeTemplate} from "primeng/api";
import {SharedModule} from "../../shared.module";
import {ProyectoService} from "../../../users/proyectos/services/proyecto.service";
import {TramiteService} from "../../../users/tramites/services/tramite.service";
import {LoginServices} from "../../../auth/login/services/login.service";
import {ViewerInterface} from "../../interfaces/viewer-interface";

@Component({
  selector: 'app-viewer-img',
  standalone: true,
    imports: [
        GalleriaModule,
        NgIf,
        PrimeTemplate,
        SharedModule
    ],
  templateUrl: './viewer-img.component.html',
  styleUrl: './viewer-img.component.scss'
})
export class ViewerImgComponent implements OnInit{
    @Input() _showLoader: boolean = false
    @Input() _displayImgView: boolean = false;
    @Input() viewer!:ViewerInterface;
    @Output() onImgtEmitterClose = new EventEmitter<boolean>;
    images: { name: string, src: string }[] = [];
    validImage: boolean = false;

    constructor(private proyectoServices: ProyectoService, public tramite: TramiteService, public loginServices: LoginServices) {
    }
    ngOnInit(): void {
        this.openFileInViewer(this.viewer.hash!,this.viewer.nombre!);
    }

    /**Metodo que visualiza los archivos*/
    openFileInViewer(hash: string, fileName: string) {
            let dataImg: { name: string, src: string } = {
                name: fileName,
                src: new URL(this.proyectoServices.getSrcFile(hash, 'inline')).toString()
            } //obtener la ruta para visualizar
            this.images.push(dataImg);
            this._showLoader = true;
            this.displayImgView = true;
    }

    imageLoaded(event: any) {
        if (event.type == 'load' && this.images.length > 0) {
            this._showLoader = false;
            this.validImage = true;
            console.log("Imagen se ha cargado correctamente");
        }
        if (event.type == 'error') {
            this._showLoader = false;
            this.validImage = false
            console.log('Error la imagen no fue cargado correctamente');
        }
    }
    get displayImgView(): boolean {
        return this._displayImgView;
    }

    set displayImgView(value: boolean) {
        this._displayImgView = value;
        if (!value) {
            this.images = [];
            this.onImgtEmitterClose.emit(false);
        }
    }
}
